import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import cx from "classnames";
import styles from "./styles.css";
import BrandLogo from "./BrandLogo.js";

const MultiBrandPatch = _ref => {
  let {
    name,
    className,
    ...props
  } = _ref;

  if (name === 'theknot') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BrandLogo, _extends({
      className: cx(className, styles['old-logo']),
      name: name
    }, props)), /*#__PURE__*/React.createElement(BrandLogo, _extends({
      className: cx(className, styles['new-logo']),
      nameForId: "theknot_catalyst",
      nameForClasses: "theknot"
    }, props)));
  }

  return /*#__PURE__*/React.createElement(BrandLogo, _extends({
    name: name
  }, props));
};

export default MultiBrandPatch;